import * as AdaptiveCards from 'adaptivecards';
import * as ReactDOM from 'react-dom';

export default abstract class AdaptiveCustomElement extends AdaptiveCards.CardElement {
    private elementHost: HTMLElement;

    protected abstract renderComponent(): JSX.Element;

    protected abstract parseInternal(json: any);

    protected get className(): string {
        return '';
    }

    protected internalRender(): HTMLElement {
        this.elementHost = document.createElement('div');
        this.elementHost.className = this.className;

        ReactDOM.render(this.renderComponent(), this.elementHost);
        return this.elementHost;
    }

    public remove(): boolean {
        if (this.elementHost) {
            ReactDOM.unmountComponentAtNode(this.elementHost);
            this.elementHost = null;
        }

        return super.remove();
    }

    public abstract getJsonTypeName();

    public abstract renderSpeech();

    public parse(json: any) {
        super.parse(json);
        this.parseInternal(json);
    }
}
